export default "__VITE_ASSET__BYpYJXam__";